import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle } from 'lucide-react';
const NAMES = ['María', 'Carlos', 'Lucía', 'Juan', 'Ana', 'Diego', 'Sofía', 'Martín', 'Laura', 'Pablo', 'Florencia', 'Matías', 'Valentina', 'Nicolás', 'Camila'];
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Neuquén', 'Corrientes', 'Posadas', 'Resistencia', 'Bahía Blanca'];
export function PurchaseNotification() {
  const [isVisible, setIsVisible] = useState(false);
  const [notification, setNotification] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    // Initial delay
    const initialTimeout = setTimeout(() => {
      triggerNotification();
    }, 15000); // First one after 15s
    // Regular interval (1.5 minutes = 90000ms)
    const interval = setInterval(() => {
      triggerNotification();
    }, 90000);
    return () => {
      clearTimeout(initialTimeout);
      clearInterval(interval);
    };
  }, []);
  const triggerNotification = () => {
    const randomName = NAMES[Math.floor(Math.random() * NAMES.length)];
    const randomCity = CITIES[Math.floor(Math.random() * CITIES.length)];
    setNotification({
      name: randomName,
      city: randomCity
    });
    setIsVisible(true);
    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);
    }, 5000);
  };
  return <AnimatePresence data-id="element-38">
      {isVisible && <motion.div initial={{
      x: 100,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 right-4 z-50 bg-white border-l-4 border-[#F59E0B] shadow-lg rounded-r-lg p-4 max-w-xs md:max-w-sm flex items-center gap-3" data-id="element-39">
          <div className="bg-green-100 p-2 rounded-full" data-id="element-40">
            <CheckCircle className="w-5 h-5 text-green-600" data-id="element-41" />
          </div>
          <div data-id="element-42">
            <p className="text-sm font-bold text-gray-900" data-id="element-43">
              {notification.name} de {notification.city}
            </p>
            <p className="text-xs text-gray-600" data-id="element-44">acaba de comprar Ultrapack</p>
            <p className="text-[10px] text-gray-400 mt-1" data-id="element-45">
              Hace unos instantes
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}